module.exports = __webpack_public_path__ + "img/202412_basic_02.de330a52.jpg";